module.exports = __webpack_public_path__ + "assets/images/batesville-hero-2x.f56ec3e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/PersonHero/assets/batesville-hero-2x.jpg
// module id = 1604
// module chunks = 0